module.exports = __webpack_public_path__ + "img/htx_img.b226bc27.png";